import { getJSONSchemaURL, Y42MetadataGitModel } from '@y42/feature/json-schema';
import { AbstractFeatureStoreModel, AbstractFeatureUIModel, UserRelatedData } from '@y42/feature/models';
import { VisualizationWidgetSettings } from '@y42/json-schema';
import type { AvailableAllChartType, ChartTypeToSettingsModel } from '../../models/widget/chart-type-constant.model';
import type { WidgetBuilderModel } from '../../models/widget/widget-builder.model';

export class VisualizationWidgetSettingsGitModel extends VisualizationWidgetSettings {
  constructor(model: VisualizationWidgetStoreModel) {
    super();
    this.$schema = getJSONSchemaURL('visualization-widget-settings');
    this.chart_type = model.chart_type;
    this.settings = model.settings;
    this.datasource_table_path = model.datasource_table_path;
    this.filters = model.filters;
    this.fields = model.fields;
    this.extra_echarts_config = model.extra_echarts_config;
  }
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class VisualizationWidgetStoreModel<T extends AvailableAllChartType = AvailableAllChartType>
  extends Y42MetadataGitModel
  implements AbstractFeatureStoreModel, VisualizationWidgetSettingsGitModel
{
  constructor(model: VisualizationWidgetStoreModel) {
    super(model);
    this.$name = model.$name;
    this.$path = model.$path;
    this.$level = model.$level;

    this.chart_type = model.chart_type as T;
    this.settings = model.settings as (typeof ChartTypeToSettingsModel)[T];
    this.datasource_table_path = model.datasource_table_path;
    this.filters = model.filters;
    this.fields = model.fields;
    this.extra_echarts_config = model.extra_echarts_config;
  }

  $name: string;
  $path: string;
  $level: number;

  chart_type: T;
  settings: (typeof ChartTypeToSettingsModel)[T];
  datasource_table_path: VisualizationWidgetSettingsGitModel['datasource_table_path'];
  filters: VisualizationWidgetSettingsGitModel['filters'];
  fields: VisualizationWidgetSettingsGitModel['fields'];
  extra_echarts_config?: VisualizationWidgetSettingsGitModel['extra_echarts_config'];
}

export type VisualizationWidgetUIModel<T extends AvailableAllChartType = AvailableAllChartType> =
  AbstractFeatureUIModel & Partial<UserRelatedData> & VisualizationWidgetStoreModel<T>;

export function extractWidgetBuilderModelFromUIModel<T extends AvailableAllChartType>(
  sourceWidget: VisualizationWidgetUIModel<T>,
): WidgetBuilderModel<T> {
  return {
    name: sourceWidget.name,
    description: sourceWidget.description,
    settings: sourceWidget.settings,
    fields: sourceWidget.fields,
    filters: sourceWidget.filters,
    chart_type: sourceWidget.chart_type,
    datasource_table_path: sourceWidget.datasource_table_path,
    extra_echarts_config: sourceWidget.extra_echarts_config,
  };
}
